import { render, staticRenderFns } from "./sortGift.vue?vue&type=template&id=0d147e90&scoped=true&"
import script from "./sortGift.vue?vue&type=script&lang=js&"
export * from "./sortGift.vue?vue&type=script&lang=js&"
import style0 from "./sortGift.vue?vue&type=style&index=0&id=0d147e90&lang=scss&scoped=true&"
import style1 from "./sortGift.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d147e90",
  null
  
)

component.options.__file = "sortGift.vue"
export default component.exports